import { Link } from 'react-router-dom';
import { Shield, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { useState } from 'react';

const Header = () => {
  const { user, login } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-white/70 backdrop-blur-xl">
      <div className="container mx-auto">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <Shield className="h-6 w-6" />
            <span className="font-heading font-bold text-xl tracking-tighter">Penocio</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/features" className="text-sm font-medium hover:text-primary" data-testid="nav-features">Features</Link>
            <Link to="/pricing" className="text-sm font-medium hover:text-primary" data-testid="nav-pricing">Pricing</Link>
            <Link to="/blog" className="text-sm font-medium hover:text-primary" data-testid="nav-blog">Blog</Link>
            {user ? (
              <Link to="/dashboard">
                <Button size="sm" data-testid="nav-dashboard-btn">Dashboard</Button>
              </Link>
            ) : (
              <Button onClick={login} size="sm" data-testid="nav-signin-btn">Sign In</Button>
            )}
          </nav>

          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="md:hidden py-4 space-y-3 border-t border-border">
            <Link to="/features" className="block text-sm font-medium" onClick={() => setMobileMenuOpen(false)}>Features</Link>
            <Link to="/pricing" className="block text-sm font-medium" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
            <Link to="/blog" className="block text-sm font-medium" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
            {user ? (
              <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)}>
                <Button size="sm" className="w-full">Dashboard</Button>
              </Link>
            ) : (
              <Button onClick={login} size="sm" className="w-full">Sign In</Button>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
